// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export function buildNewlineCollection(items: string[] | number[]): string {
  return items.join("\n");
}
